<template>
    <div class="user-amount-page">
      <!-- 搜索区域 -->
      <div class="search-bar">
        <el-form :model="searchForm" inline @submit.prevent="getUserList">
          <!-- 手机号搜索 -->
          <el-form-item label="手机号">
            <el-input 
              v-model="searchForm.phone" 
              placeholder="请输入手机号" 
              clearable
              style="width: 200px;"
            />
          </el-form-item>
          <!-- 昵称搜索 -->
          <!-- <el-form-item label="昵称">
            <el-input 
              v-model="searchForm.nickname" 
              placeholder="请输入昵称" 
              clearable
              style="width: 200px;"
            />
          </el-form-item> -->
          <!-- 状态筛选 -->
          <el-form-item label="账户状态">
            <el-select 
              v-model="searchForm.status" 
              placeholder="请选择状态" 
              clearable
            >
              <el-option label="有效" value="0" />
              <el-option label="冻结" value="1" />
            </el-select>
          </el-form-item>
          <!-- 操作按钮 -->
          <el-form-item>
            <el-button type="primary" @click="getUserList">查询</el-button>
            <el-button @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
  
      <!-- 列表区域 -->
      <el-table 
        :data="userList" 
        border 
        stripe 
        v-loading="loading"
        style="width: 100%;"
      >
        <el-table-column prop="id" label="用户ID" width="100" align="center" />
        <!-- <el-table-column prop="nickname" label="昵称"  align="center" /> -->
        <el-table-column prop="openid" label="openid" width="150" align="center" />
        <el-table-column prop="phone" label="手机号" width="150" align="center" />
        <!-- <el-table-column prop="addressDetails" label="详细地址" min-width="200" align="center" /> -->
        <el-table-column prop="totalAmount" label="账户总额"  align="center" />
        <el-table-column prop="currentAmount" label="可提现金额"  align="center" />
        <el-table-column prop="frozenAmount" label="待入账金额"  align="center" />
        <el-table-column 
          prop="status" 
          label="账户状态" 
          width="100" 
          align="center"
        >
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 0 ? 'success' : 'danger'">
              {{ scope.row.status === 0 ? '有效' : '冻结' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="200" align="center" />
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="toDetail(scope.row)">查看记录</el-button>
          </template>
        </el-table-column>
      </el-table>
  
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.pageNo"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        style="text-align: right; margin-top: 20px;"
      />
    </div>
  </template>
  
  <script>
  import moment from 'moment';
  import { getUserAmountList} from "@/api/recyclingMachine";
  export default {
    name: 'WithdrawUserList',
    data() {
      return {
        loading: false,
        userList: [],
        // 搜索表单
        searchForm: {
          phone: '',
          nickname: '',
          wlCommunityId: '',
          status: '',
        },
        // 分页参数
        pagination: {
          pageNo: 1,
          pageSize: 10,
          total: 0,
        },
      };
    },
    created() {
      this.getUserList();
    },
    methods: {
      // 获取可提现用户列表
      async getUserList() {
        this.loading = true;
        try {
          const params = {
            ...this.searchForm,
            ...this.pagination,
            // 按可提现金额排序（可根据需求调整）
            orderByType: 1,
          };
          const res = await getUserAmountList(params);
          if (res.code === 200) {
            this.userList = res.data.records.map(item => ({
              ...item,
              createTime: moment(item.createTime).format('YYYY-MM-DD HH:mm:ss'),
            }));
            this.pagination.total = res.data.total;
          }
        } catch (error) {
          console.error('获取可提现用户列表失败：', error);
          this.$message.error('数据加载失败，请重试');
        } finally {
          this.loading = false;
        }
      },
  
      // 重置搜索条件
      resetSearch() {
        this.searchForm = {
          phone: '',
          nickname: '',
          wlCommunityId: '',
          status: '',
        };
        this.pagination.pageNo = 1;
        this.getUserList();
      },
  
      // 每页条数变化
      handleSizeChange(val) {
        this.pagination.pageSize = val;
        this.pagination.pageNo = 1;
        this.getUserList();
      },
  
      // 当前页码变化
      handleCurrentChange(val) {
        this.pagination.pageNo = val;
        this.getUserList();
      },
  
      // 跳转到用户详情页
      toDetail(row) {
        this.$router.push({
          name: '用户钱包记录列表',
          params: { phone: row.phone }
       });
      },
    },
  };
  </script>
  
  <style scoped>
  .user-amount-page {
    padding: 20px;
    background: #f7f7f7;
    min-height: calc(100vh - 100px);
  }
  
  .search-bar {
    padding: 20px;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
  }
  </style>